import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { assert, isDefined } from '@sama/js-core';
import { pick } from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  ImageObjectState,
  isImageObjectState,
  isResponseObject,
  isTextObjectState,
  isVideoObjectState,
  ObjectState,
  TextObjectState,
  VideoObjectState,
} from '../../../../cross-team-shared/annotation/shared/state/object-state';
import { TokenManagementService } from '../../../../cross-team-shared/misc-services/token-management.service';
import { strictValues } from '../../../../cross-team-shared/misc-utils/strict-record';
import { TaskWorkspaceStore } from '../../../h3ml/state/task-workspace-store';
import { ResponseEditorComponent } from '../response-editor/response-editor.component';
import { SelectableObjectComponent } from '../selectable-object/selectable-object.component';

@Component({
  selector: 'h3-prompt',
  templateUrl: './prompt.component.html',
  styleUrl: './prompt.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ResponseEditorComponent, SelectableObjectComponent],
})
export class PromptComponent implements OnInit {
  @Input({ required: true }) prompt!: ObjectState;

  private readonly store = inject(TaskWorkspaceStore);
  private readonly tokenManagementService = inject(TokenManagementService);

  image?: ImageObjectState;
  video?: VideoObjectState;
  text?: TextObjectState;
  response!: ObjectState;
  assetUrl$?: Observable<string>;

  ngOnInit() {
    const childObjects = strictValues(
      pick(this.store.state().objects, ...this.prompt.childObjectIds),
    );
    this.image = childObjects.find(isImageObjectState);
    if (this.image) {
      this.assetUrl$ = this.buildAssetUrl$(this.image);
    }

    this.video = childObjects.find(isVideoObjectState);
    if (this.video) {
      this.assetUrl$ = this.buildAssetUrl$(this.video);
    }

    this.text = childObjects.find(isTextObjectState);
    const response = childObjects.find(isResponseObject);
    assert(isDefined(response), 'Prompt should have a response');
    this.response = response;
  }

  private buildAssetUrl$(object: ImageObjectState | VideoObjectState) {
    return this.tokenManagementService
      .getToken$('assets')
      .pipe(map((token) => `${object.tags.url}?access_key=${token}`));
  }
}
